(ns bleene.dag.dag-context
  (:require
   [react :as react]
   [reagent.core :as reagent]
   [applied-science.js-interop :as jsi]))


(def context
  (react/createContext))


(def Provider
  (jsi/get context :Provider))
